import React from 'react';
import { Redirect, Route } from 'react-router-dom';

export default function ProtectedRoute({ component: Component, ...rest }) {
  return sessionStorage.getItem('user')!=null ? (
    <Route {...rest} render={(props) => <Component {...rest} {...props} />} />
  ) : (
    <Redirect to={'/'+process.env.REACT_APP_DASHBOARD_TOKEN+'/dashboard/login'}/>
  );
}